import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {CreativePageState} from './creativePage.types';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {Creative} from '../../creatives.types';
import {SharePermission} from 'common/src/modules/sharing/sharing.index';
import {CampaignUsage} from 'common/src/modules/campaigns/campaigns.types';

const creativePageInitialState: CreativePageState = {
  creative: null,
  sharePermissions: [],
  loading: true,
};

const creativePageReducer = createSlice({
  name: BreadcrumbName.CreativePage,
  initialState: creativePageInitialState,
  reducers: {
    resetState: () => creativePageInitialState,
    setCreativePageData: (
      state,
      action: PayloadAction<{creative: Creative; sharePermissions: SharePermission[]}>,
    ) => {
      state.creative = action.payload.creative;
      state.sharePermissions = action.payload.sharePermissions;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    addCampaignToCreative: (state, action: PayloadAction<number>) => {
      if (state.creative) {
        const newCampaignUsage: CampaignUsage = {
          campaignId: action.payload,
          isUsedInActiveCampaignVersion: false,
          isCampaignActive: false,
        };

        state.creative.usedInCampaigns = [...state.creative.usedInCampaigns, newCampaignUsage];
      }
    },
    updateCreative: (state, action: PayloadAction<Partial<Creative>>) => {
      if (state.creative) {
        state.creative = {...state.creative, ...action.payload};
      }
    },
  },
});

const {resetState, setCreativePageData, setLoading, addCampaignToCreative, updateCreative} =
  creativePageReducer.actions;

export {resetState, setCreativePageData, setLoading, addCampaignToCreative, updateCreative};

export default creativePageReducer.reducer;
